import { render, staticRenderFns } from "./VideoRecord.vue?vue&type=template&id=536b986d&scoped=true"
import script from "./VideoRecord.vue?vue&type=script&lang=js"
export * from "./VideoRecord.vue?vue&type=script&lang=js"
import style0 from "./VideoRecord.vue?vue&type=style&index=0&id=536b986d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b986d",
  null
  
)

export default component.exports